import React, { useMemo } from "react";
import CompletedFlag from "./CompletedFlag";
import ImageWithPlaceholder from "./ImageWithPlaceholder";
import MVMIcon from "./MVMIcon";
const MissionCard = ({ mission, setShowError }) => {
    const renderCompletedFlag = () => {
        if (mission.isCompleted) {
            return (React.createElement("div", { className: "mission-slider-flag" },
                React.createElement(CompletedFlag, { isConq: mission.isConqueror })));
        }
        return null;
    };
    const showViewMissionButton = useMemo(() => !mission.isConqueror, [mission]);
    const showViewChallengeButton = useMemo(() => mission.isConqueror && mission.categoryId == 1, [mission]);
    const showDisabledButton = useMemo(() => mission.isConqueror && mission.categoryId != 1, [mission]);
    return (React.createElement("div", { className: "mission-slider" },
        React.createElement("div", { className: "mission-slider-name" },
            React.createElement("h3", null, mission.name)),
        React.createElement("hr", null),
        React.createElement("div", { className: "mission-slider-group" },
            React.createElement("p", null, mission.groupName)),
        React.createElement("div", { className: "mission-slider-stats" },
            React.createElement(ImageWithPlaceholder, { className: "mission-slider-avatar" +
                    (mission.isConqueror ? " rounded-circle" : ""), src: "/" + mission.imgAvatar, type: "mission" }),
            React.createElement("div", { className: "d-flex flex-column justify-content-center" },
                React.createElement("p", { className: "mission-slider-statsrow d-flex small primary-color my-0 text-truncate" },
                    React.createElement("span", { className: "weight-700 me-1" }, "Started:"),
                    mission.startDate),
                React.createElement("p", { className: "mission-slider-statsrow d-flex small primary-color my-0 text-truncate" },
                    React.createElement("span", { className: "weight-700 me-1" }, "Goal: "),
                    mission.missionGoal,
                    " ",
                    mission.distanceUnit),
                React.createElement("div", { className: "mission-slider-statsrow" }, mission.exerciseTypes.length > 0 && (React.createElement("div", { className: "d-flex" },
                    React.createElement("p", { className: "small primary-color weight-700 my-0 me-1" }, "How:"),
                    mission.exerciseTypes.map((alias) => (React.createElement(MVMIcon, { key: alias, icon: alias, height: 20, width: 20 })))))))),
        showDisabledButton && (React.createElement("a", { className: "my-3 d-flex conq-btn w-100 align-items-center justify-content-center conq-btn-greyout", href: "#", onClick: (e) => {
                e.preventDefault();
                setShowError(true);
            } }, "VIEW CHALLENGE")),
        showViewChallengeButton && (React.createElement("a", { className: "my-3 d-flex conq-btn w-100 align-items-center justify-content-center", href: `/missions/${mission.id}/${mission.slug}` }, "VIEW CHALLENGE")),
        showViewMissionButton && (React.createElement("a", { className: "my-3 bg-img-btn blue-img d-flex w-100 align-items-center justify-content-center", href: `/missions/${mission.id}/${mission.slug}` }, "VIEW MISSION")),
        React.createElement("hr", null),
        React.createElement("div", { className: "d-flex align-items-center justify-content-between flex-fill" },
            React.createElement("div", { className: "d-flex", 
                //@ts-ignore
                rel: "tooltip", title: (mission.isFundraising ? "" : "No ") + "Fundraising" },
                React.createElement(MVMIcon, { icon: "funds", className: "grey", height: 23, width: 23 }),
                React.createElement("p", { className: "mission-slider-test" }, mission.isFundraising ? "YES" : "NO")),
            React.createElement("div", { className: "d-flex", 
                //@ts-ignore
                rel: "tooltip", title: mission.type === "group"
                    ? "Group mission - number of people on this mission"
                    : "Solo mission" },
                React.createElement(MVMIcon, { icon: "participants", className: "grey", height: 23, width: 23 }),
                React.createElement("p", { className: "mission-slider-test" }, mission.type === "group" ? mission.participantsCt : "")),
            React.createElement("div", { className: "d-flex", 
                //@ts-ignore
                rel: "tooltip", title: "Completion" },
                React.createElement(MVMIcon, { icon: "dial", className: "grey", height: 23, width: 23 }),
                React.createElement("p", { className: "mission-slider-test" },
                    mission.distancePct,
                    "%"))),
        renderCompletedFlag()));
};
export default MissionCard;
